import React, { useMemo, useState } from "react";
import { Users } from "lucide-react";

import { useAppSelector } from "../../../app/hooks";

import { InvestigationEntityCard } from "./InvestigationEntityCard";

import AddPartyModal from "./AddPartyModal";
import ManagePartyModal from "./ManagePartyModal";
import { PARTY_TYPE_LABELS } from "../../../api/PartiesInvolved";
import { selectAllPartiesInvolved } from "../../partiesinvolved/logic/PartiesInvolvedSelectors";
import { EntityModalType } from "./LoanAccountCard";

const LegacyPartyCard: React.FC = () => {
  const parties = useAppSelector(selectAllPartiesInvolved);

  const [activeModal, setActiveModal] =useState<EntityModalType | null>(null);
  const [previousModal, setPreviousModal] = useState<EntityModalType | null>(null);

  const partyItems = useMemo(() =>
      parties.map(
        party =>
        `${party.name} (${
          PARTY_TYPE_LABELS[party.party_type as keyof typeof PARTY_TYPE_LABELS] ?? party.party_type
        })`
      ),
      [parties]
  );

  const closeModal = () => {
    setActiveModal(null);
    setPreviousModal(null);
  };

  return (
    <>
      <InvestigationEntityCard
        title="Parties Involved"
        items={partyItems}
        onAdd={() =>{
          setPreviousModal(null)
          setActiveModal(EntityModalType.ADD)
        } 
        }
        onManage={() =>{
          setPreviousModal(null)
          setActiveModal(EntityModalType.MANAGE)
        } 
        }
        popoverProps={{
          title: "Parties Involved",
          items: partyItems,
          icon: (
            <Users
              size={16}
              className="text-[#94A3B8]"
            />
          ),
        }}
        emptyState={{
          icon: <Users size={18} className="text-[#94A3B8]"/>,
          message: "No parties added",
        }}
      />

      {activeModal === EntityModalType.MANAGE && (
        <ManagePartyModal
          onClose={closeModal}
          onAdd={() =>{
            setPreviousModal(EntityModalType.MANAGE)
            setActiveModal(EntityModalType.ADD)
           }  
          }
        />
      )}

      {activeModal === EntityModalType.ADD && (
        <AddPartyModal
          onClose={closeModal}
          onBack={() => {
            if (previousModal) {
              setActiveModal(previousModal);
              setPreviousModal(null);
            } else {
              closeModal();
            }
          }}
        />
      )}
    </>
  );
};

export default LegacyPartyCard;